import { BaseBadge } from './BaseBadge'
import React from 'react'
import { Tooltip } from '../ui/tooltip'
import { State, stateOptions } from '../../constants'

export const StateBadge = ({
    state,
    className,
    parent_ad_group_status,
    parent_campaign_status,
}) => {
    const { value, message } = resolveValueAndMessage(
        state,
        parent_ad_group_status,
        parent_campaign_status,
    )

    const badge = <BaseBadge options={stateOptions} value={value} className={className} />

    if (!message) {
        return badge
    } else {
        return (
            <Tooltip content={<div style={{ maxWidth: '300px' }}>{message}</div>}>{badge}</Tooltip>
        )
    }
}

export const stateTextToEnum = (v) => {
    switch (v) {
        case 'ENABLED':
            return State.Enabled
        case 'PAUSED':
            return State.Paused
        case 'ARCHIVED':
            return State.Archived
        default:
            return v
    }
}

export const resolveValueAndMessage = (
    state = 0,
    parent_ad_group_status,
    parent_campaign_status,
) => {
    state = stateTextToEnum(state)
    let v = state?.toString() ?? ''
    let message = ''
    const paused = []
    const archived = []

    parent_ad_group_status = stateTextToEnum(parent_ad_group_status)
    parent_campaign_status = stateTextToEnum(parent_campaign_status)

    const vals = [
        state,
        parent_ad_group_status || undefined,
        parent_campaign_status || undefined,
    ].filter((v) => v !== undefined)

    // Enabled if all are enabled
    let finalState = State.Enabled
    if (vals.every((v) => v === State.Enabled)) {
        finalState = State.Enabled
    } else if (vals.some((v) => v === State.Archived)) {
        finalState = State.Archived
    } else {
        finalState = State.Paused
    }

    // Determine which, if any, parents are paused or archived
    if (parent_ad_group_status === State.Archived) {
        archived.push('ad group')
    } else if (parent_ad_group_status === State.Paused) {
        paused.push('ad group')
    }

    if (parent_campaign_status === State.Archived) {
        archived.push('campaign')
    } else if (parent_campaign_status === State.Paused) {
        paused.push('campaign')
    }

    let parentState = State.Enabled

    if (parent_ad_group_status === State.Archived || parent_campaign_status === State.Archived) {
        parentState = State.Archived
    } else if (parent_ad_group_status === State.Paused || parent_campaign_status === State.Paused) {
        parentState = State.Paused
    }

    if (
        (state === State.Enabled && parentState !== State.Enabled) ||
        (state === State.Paused && parentState === State.Archived)
    ) {
        v = parentState + ',' + v

        let currentStateText = 'enabled'
        if (state === State.Paused) {
            currentStateText = 'paused'
        }

        message = `Even though this item is ${currentStateText}, `

        const parts = {
            paused: paused.length > 0 ? "it's parent " + paused.join(' and parent ') : '',
            archived: archived.length > 0 ? "it's parent " + archived.join(' and parent ') : '',
        }

        const parts2 = []
        if (parts.paused) {
            parts2.push(parts.paused + ` ${paused.length > 1 ? 'are' : 'is'} paused`)
        }
        if (parts.archived) {
            parts2.push(parts.archived + ` ${archived.length > 1 ? 'are' : 'is'} archived`)
        }
        message +=
            parts2.join(' and ') +
            '. This means this item is effectively ' +
            stateOptions[v]?.text?.toLowerCase() +
            '.'
    }

    let out = '' + state
    if (finalState !== state) {
        out = finalState + ',' + out
    }

    return {
        value: out,
        message,
    }
}
